import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { RoleOption } from 'shared/types/roles';
import { MinimalNewTask, NewTask } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';

import { dateToFirestoreTimestamp } from './converters/date-to-firestore-timestamp';
import { newTaskConverter } from './converters/task';
import {
  BatchDocuments,
  CollectionOptions,
  getAuthentication,
  getCollection,
  getDatabase,
} from './helpers';

export const createTasks = async (tasks: MinimalNewTask[]) => {
  // Get the currently authenticated user
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const taskCollection = getCollection(CollectionOptions.Tasks);

  if (tasks.length === 1) {
    // if only one task is being created, we can use setDoc directly
    const docRef = doc(taskCollection);
    setDoc(docRef, {
      ...dateToFirestoreTimestamp(
        newTaskConverter(tasks[0] as unknown as NewTask),
      ),
      id: docRef.id,
      updatedAt: serverTimestamp() as unknown as Timestamp,
      parentIds: null,
      roles: { [RoleOption.Owner]: user.uid, [RoleOption.All]: [user.uid] },
    });
    return;
  }

  const batchDocuments = new BatchDocuments(getDatabase());

  tasks.forEach((task) => {
    const docRef = doc(taskCollection);
    batchDocuments.addDocument({
      ref: docRef,
      data: {
        ...dateToFirestoreTimestamp(
          newTaskConverter(task as unknown as NewTask),
        ),
        id: docRef.id,
        updatedAt: serverTimestamp() as unknown as Timestamp,
        parentIds: null,
        roles: { [RoleOption.Owner]: user.uid, [RoleOption.All]: [user.uid] },
      },
    });
  });

  batchDocuments.commit();
};
